import type { FC, PropsWithChildren } from 'react';
import type { IconComponent } from '@THC/components/Icon';
import { Icon } from '@THC/components/Icon';

import styles from './EarlyDocumentsCard.module.scss';

interface EarlyDocumentsCardProps {
	filled?: boolean;
	icon: IconComponent;
}

export const EarlyDocumentsCard: FC<PropsWithChildren<EarlyDocumentsCardProps>> = ({ children, filled, icon }) => {
	return (
		<div className={styles.item}>
			<Icon filled={filled}>{icon}</Icon>
			<span className={styles.stat}>{children}</span>
		</div>
	);
};
